import { createIcon } from "@chakra-ui/react";

export const DownloadUserGuideIcon = createIcon({
  displayName: "DownloadUserGuideIcon",
  viewBox: "0 0 20 20",
  path: (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 2.02988V15.0299M10 2.02988C7.181 1.19888 5.285 0.953879 1.97101 1.00688C1.71123 1.01186 1.46382 1.11878 1.28217 1.30455C1.10051 1.49032 0.99917 1.74006 1.00001 1.99988V12.9999C1.00001 13.5629 1.46601 14.0139 2.03001 14.0069C5.15201 13.9639 7.048 14.2189 10 15.0299M10 2.02988C12.819 1.19888 14.715 0.953879 18.029 1.00688C18.2888 1.01186 18.5362 1.11878 18.7178 1.30455C18.8995 1.49032 19.0008 1.74006 19 1.99988V12.9999C19 13.5629 18.534 14.0139 17.97 14.0069C14.848 13.9639 12.952 14.2189 10 15.0299" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
});
